import { useEffect, useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import apiService from '../../../utlis/apiService';
import { apiUrl } from '../../../config';

const DueDateNotSet = () => {
  	const [data, setData] = useState([]);
  	const [totalResults, setTotalResults] = useState(0);
	const [paginationModel, setPaginationModel] = useState({
		pageSize: 50,
		page: 0,
	});
	const [loading, setLoading] = useState(false);

	const pageOption = [10, 25, 50, 100];

    useEffect(() => {
        getData()
    },[paginationModel]);

    const getData = async () => {
		setLoading(true);
        try {
			const response = await apiService.get('/report/due-date-not-set', {
                params: {
                    page: paginationModel.page,
                    pageSize: paginationModel.pageSize,
                },
            });
			setData(response?.data?.students);
			setTotalResults(response?.data?.totalResults);
        } catch (error) {
          	console.error(error);
        } finally {
            setLoading(false);
        }
	};

	const exportReport = async () => {
        try {
            const response = await apiService.get('/export/report/due-date-not-set');
            if(response?.data?.status === 'success') {
                
                window.open(`${apiUrl}${response?.data?.path}`, '_blank');
            }
        }
        catch (error) {
            console.error(error);
        }
    }

  	return (
		<div style={{ height: '75vh', width: '100%' }}>
			<Typography variant="h4" gutterBottom>
				DUE DATE NOT SET REPORT
			</Typography>
			<Grid container spacing={2} alignItems="center" sx={{ marginBottom: 3 }}>
				<Grid item xs={4}>
				</Grid>
				<Grid item xs={8}>
					<Button variant="outlined" sx={{ float: 'right' }} title="Export" onClick={exportReport}><DownloadIcon /></Button>
				</Grid>
			</Grid>
			{loading ? (
				<div style={{ textAlign: 'center' }}>
					<CircularProgress style={{ margin: 'auto' }} />
				</div>

			) : (
				<DataGridPro
					getRowId={(row) => row._id}
					rows={data}
					getRowHeight={() => 'auto'}
					disableDensitySelector
					columns={[
						{ field: 'studentId', headerName: 'ID', flex: 1 },
						{ field: 'name', headerName: 'Name', flex: 1, valueGetter: (params) => params?.row?.firstName + ' ' +  params?.row?.lastName},
						{ field: 'phoneNumber', headerName: 'Phone Number', flex: 1 },
						{ field: 'email', headerName: 'Email', flex: 1 },
					]}
					pagination
					paginationModel={paginationModel}
					rowCount={totalResults}
					paginationMode="server"
					onPaginationModelChange={setPaginationModel}
					pageSizeOptions={pageOption}
				/>
			)}
		</div>
  	);
};

export default DueDateNotSet;
